import React from "react";
import { Link } from "react-router-dom";
import { MdArrowOutward } from "react-icons/md";

const destinations = [
  {
    id: 1,
    title: "experience",
    blurb: "Where I've worked and what I built while I was there.",
    url: "/#experience",
  },
  {
    id: 2,
    title: "about me",
    blurb: "The longer story — background, interests, and how I work.",
    url: "/about",
  },
  {
    id: 3,
    title: "projects",
    blurb: "The full library of experiments and case studies.",
    url: "/projects",
  },
];

const NoPage = () => {
  return (
    <section className="min-h-screen flex items-center py-32 bg-background text-text">
      <div className="max-w-6xl mx-auto px-6 w-full">

        <div className="flex flex-col mb-16 space-y-2">
          <h2 className="text-sm uppercase tracking-[0.5em] text-secondary font-bold ml-2">
            Error 404
          </h2>
          <h3 className="text-5xl md:text-6xl font-bold tracking-tighter">
            page not found.
          </h3>
          <p className="text-secondary font-light max-w-xl pt-4">
            This page doesn't exist — it may have moved or never been here at
            all. Here's where you might want to go instead.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {destinations.map(({ id, title, blurb, url }) => (
            <Link
              key={id}
              to={url}
              className="group bg-secondary/5 border border-border rounded-[2.5rem] p-10 flex flex-col justify-between transition-all duration-500 hover:bg-border hover:border-text min-h-[260px]"
            >
              <div className="mb-8 w-14 h-14 rounded-full bg-background border border-border flex items-center justify-center group-hover:scale-110 group-hover:border-text transition-all duration-500">
                <MdArrowOutward size={24} />
              </div>

              <div>
                <h4 className="text-2xl font-bold tracking-tight mb-2">
                  {title}
                </h4>
                <p className="text-secondary text-sm font-light">{blurb}</p>
              </div>
            </Link>
          ))}
        </div>

        <Link
          to="/"
          className="inline-block mt-16 text-sm uppercase tracking-widest font-semibold text-secondary hover:text-text transition-colors"
        >
          ← back to home
        </Link>

      </div>
    </section>
  );
};

export default NoPage;
